<template>
  <section class="transaction">
    <div class="container">
      <div class="transaction-content">
        <div class="item-one">
          <div class="transaction-head">
            <h2 data-aos="fade-up">Effortless Crypto Transactions</h2>
            <p data-aos="fade-up">
              Seamlessly trade your crypto assets with confidence. Whether
              you're receiving, selling, or cashing out your cryptocurrency, our
              secure and user-friendly platform ensures fast transactions at the
              best rates. Experience hassle-free crypto trading today!
            </p>
            <router-link to="/download" class="btn" data-aos="fade-up"
              >Download App</router-link
            >
          </div>
        </div>
        <div class="img">
          <img
            src="/img/crypto-transaction.svg"
            alt="illustration_02"
            data-aos="zoom-in"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      lists: [
        {
          dot: "dot.svg",
          context:
            "Easily compare rates for different digital assets and gift cards.",
        },
        {
          dot: "dot.svg",
          context: "Your withdrawal requests are processed quickly.",
        },
        {
          dot: "dot.svg",
          context: "Secure the top spot on our leaderboard and win cash prices",
        },
      ],
    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/scss/global.scss";
.transaction {
  background-color: #fbfbff;
  padding: 3rem 0;
  & .img {
    margin: 2rem 0 0;
  }
  &-content {
    & .item-one h2 {
      margin-bottom: 1rem;
    }
  }
  .transaction-head {
    & p {
      color: #65656a;
    }
  }
  .item-one .btn {
    display: block;
    border-radius: 10px;
    text-align: center;
    margin-top: 1rem;
    padding: 1rem 4rem;
    & a {
      color: $white;
    }
  }
}

@media screen and (min-width: 700px) {
  .transaction-content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: 5rem; /* Reduce gap to avoid extra spacing */
    padding-top: 1rem;

    & h2 {
      font-size: 25px;
      font-weight: 700;
    }
    & p:first-child {
      font-size: 20px;
    }
  }

  .transaction {
    padding: 0; /* Remove extra padding */

    & .btn {
      width: 250px;
      margin: 2rem 0 1rem; /* Reduce margin */
    }

    & .img {
      margin: 0 0 0 auto;
    }
  }
}

@media screen and (min-width: 1000px) {
  .transaction-content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 3rem;
    background-color: #fbfbff;

    .item-one {
      & h2 {
        font-size: 30px;
      }
    }
    & p {
      font-size: 18px;
    }
  }
  .transaction {
    & .btn {
      width: 250px;
      font-weight: 500;
    }
  }
}
@media screen and (min-width: 1200px) {
  .transaction-content {
    padding: 0 0 0 2rem; /* Remove unnecessary padding */
  }
  .transaction {
    background-color: transparent;
  }
}

@media screen and (min-width: 1400px) {
  .container {
    width: 1200px;
  }
  .transaction-content {
    justify-content: center;
    .item-one {
      & h2 {
        font-size: 36px;
        line-height: 24px;
        margin-bottom: 1.5rem;
      }
    }
  }
  .transaction .btn {
    width: 350px;
    height: 56px;
    padding: 11px 31px;
  }
}
</style>
